import React from "react";
import CollapsibleSection from "../CollapsibleSection";
import PeriodDateSelector from "../../PeriodDateSelector";
import styles from "../ViewOptionsPanel.module.scss";

const PeriodDateSection = ({
  title = "Tarih",
  mode = "day",
  anchorDate,
  startDate,
  endDate,
  onChange,
  maxDate,
  defaultOpen = true,
}) => (
  <CollapsibleSection title={title} defaultOpen={defaultOpen}>
    <div className={styles.periodDate}>
      <PeriodDateSelector
        className={styles.periodDateSelector}
        mode={mode}
        anchorDate={anchorDate}
        startDate={startDate}
        endDate={endDate}
        onChange={onChange}
        maxDate={maxDate}
      />
    </div>
  </CollapsibleSection>
);

export default PeriodDateSection;
